import React from "react"

const LaptopSvg = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			width={"729"}
			height={"443"}
			viewBox={"0 0 729 443"}
			fill={"none"}
			{...props}
		>
			<g clip-path={"url(#clip0_680_3053)"}>
				<path
					d={
						"M623.67 0.600006H11.9301C5.67271 0.600006 0.600098 5.67262 0.600098 11.93V431.08C0.600098 437.337 5.67271 442.41 11.9301 442.41H623.67C629.927 442.41 635 437.337 635 431.08V11.93C635 5.67262 629.927 0.600006 623.67 0.600006Z"
					}
					stroke={"white"}
					stroke-width={"1.2"}
					stroke-miterlimit={"10"}
				/>
				<path
					d={
						"M11.9301 0.600006H623.67C629.93 0.600006 635 5.67001 635 11.93V32.32H0.600098V11.93C0.600098 5.67001 5.6701 0.600006 11.9301 0.600006Z"
					}
					stroke={"white"}
					stroke-width={"1.2"}
					stroke-miterlimit={"10"}
				/>
				<path
					d={
						"M452.99 25.15H187.9C182.89 25.15 178.84 21.09 178.84 16.09C178.84 11.08 182.9 7.03 187.9 7.03H452.99C458 7.03 462.05 11.09 462.05 16.09C462.05 21.1 457.99 25.15 452.99 25.15Z"
					}
					stroke={"white"}
					stroke-width={"1.2"}
					stroke-miterlimit={"10"}
				/>
				<path
					d={
						"M124.58 25H97.3901C92.3801 25 88.3301 20.94 88.3301 15.94C88.3301 10.93 92.3901 6.88 97.3901 6.88H124.58C129.59 6.88 133.64 10.94 133.64 15.94C133.64 20.95 129.58 25 124.58 25Z"
					}
					stroke={"white"}
					stroke-width={"1.2"}
					stroke-miterlimit={"10"}
				/>
				<path
					d={
						"M26.3498 13.06C28.0198 13.06 29.3698 14.42 29.3698 16.08C29.3698 17.74 28.0098 19.1 26.3498 19.1C24.6898 19.1 23.3298 17.74 23.3298 16.08C23.3298 14.42 24.6898 13.06 26.3498 13.06ZM26.3498 11.55C23.8498 11.55 21.8198 13.58 21.8198 16.08C21.8198 18.58 23.8498 20.61 26.3498 20.61C28.8498 20.61 30.8798 18.58 30.8798 16.08C30.8798 13.58 28.8498 11.55 26.3498 11.55Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M41.76 13.06C43.43 13.06 44.78 14.42 44.78 16.08C44.78 17.74 43.42 19.1 41.76 19.1C40.1 19.1 38.74 17.74 38.74 16.08C38.74 14.42 40.1 13.06 41.76 13.06ZM41.76 11.55C39.26 11.55 37.23 13.58 37.23 16.08C37.23 18.58 39.26 20.61 41.76 20.61C44.26 20.61 46.29 18.58 46.29 16.08C46.29 13.58 44.26 11.55 41.76 11.55Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M57.1696 13.06C58.8396 13.06 60.1896 14.42 60.1896 16.08C60.1896 17.74 58.8296 19.1 57.1696 19.1C55.5096 19.1 54.1497 17.74 54.1497 16.08C54.1497 14.42 55.5096 13.06 57.1696 13.06ZM57.1696 11.55C54.6696 11.55 52.6396 13.58 52.6396 16.08C52.6396 18.58 54.6696 20.61 57.1696 20.61C59.6696 20.61 61.6996 18.58 61.6996 16.08C61.6996 13.58 59.6696 11.55 57.1696 11.55Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M99.1997 15.94L102.8 12.34C103.02 12.12 103.02 11.76 102.8 11.54C102.58 11.32 102.22 11.32 102 11.54L97.9897 15.55C97.7697 15.77 97.7697 16.13 97.9897 16.35L102 20.36C102.11 20.47 102.26 20.53 102.4 20.53C102.54 20.53 102.69 20.47 102.8 20.36C103.02 20.14 103.02 19.78 102.8 19.56L99.1997 15.96V15.94Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M126.6 15.54L122.59 11.53C122.37 11.31 122.01 11.31 121.79 11.53C121.57 11.75 121.57 12.11 121.79 12.33L125.39 15.93L121.79 19.53C121.57 19.75 121.57 20.11 121.79 20.33C121.9 20.44 122.05 20.5 122.19 20.5C122.33 20.5 122.48 20.44 122.59 20.33L126.6 16.32C126.82 16.1 126.82 15.74 126.6 15.52V15.54Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M112.561 6.88227L111.431 6.88937L111.545 25.159L112.675 25.1519L112.561 6.88227Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M596.29 15.33H592.33V11.27C592.33 10.96 592.08 10.7 591.76 10.7C591.44 10.7 591.19 10.95 591.19 11.27V15.33H587.22C586.91 15.33 586.65 15.58 586.65 15.9C586.65 16.22 586.9 16.47 587.22 16.47H591.19V20.34C591.19 20.65 591.44 20.91 591.76 20.91C592.08 20.91 592.33 20.66 592.33 20.34V16.47H596.29C596.6 16.47 596.86 16.22 596.86 15.9C596.86 15.58 596.61 15.33 596.29 15.33Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M620.08 11.17H615.55C614.61 11.17 613.85 11.93 613.85 12.87V14.57H614.98V12.87C614.98 12.56 615.23 12.3 615.54 12.3H620.07C620.38 12.3 620.64 12.55 620.64 12.87V17.4C620.64 17.71 620.39 17.97 620.07 17.97H618.37V19.1H620.07C621.01 19.1 621.77 18.34 621.77 17.4V12.87C621.77 11.93 621.01 11.17 620.07 11.17H620.08Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M617.82 13.44H613.29C612.35 13.44 611.59 14.2 611.59 15.14V19.67C611.59 20.61 612.35 21.37 613.29 21.37H617.82C618.76 21.37 619.52 20.61 619.52 19.67V15.14C619.52 14.2 618.76 13.44 617.82 13.44ZM618.39 19.67C618.39 19.98 618.14 20.24 617.82 20.24H613.29C612.98 20.24 612.73 19.99 612.73 19.67V15.14C612.73 14.83 612.98 14.57 613.29 14.57H617.82C618.13 14.57 618.39 14.82 618.39 15.14V19.67Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M453.93 11.54C453.62 11.54 453.36 11.79 453.36 12.11V13.03C452.6 12.09 451.33 11.54 450.04 11.54C447.54 11.54 445.52 13.57 445.52 16.07C445.52 18.57 447.56 20.6 450.06 20.6C451.88 20.6 453.53 19.51 454.24 17.83C454.36 17.54 454.23 17.21 453.94 17.09C453.65 16.97 453.32 17.1 453.2 17.39C452.67 18.65 451.44 19.47 450.07 19.47C448.2 19.47 446.67 17.94 446.67 16.07C446.67 14.2 448.19 12.67 450.07 12.67C451.04 12.67 451.96 13.05 452.6 13.81H451.72C451.41 13.81 451.15 14.06 451.15 14.38C451.15 14.7 451.4 14.95 451.72 14.95H453.99C454.3 14.95 454.5 14.69 454.5 14.38V12.11C454.5 11.8 454.25 11.54 453.93 11.54Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M198.95 20.32L196.68 18.05C196.68 18.05 196.62 18.01 196.59 17.99C197.19 17.2 197.54 16.26 197.54 15.25C197.54 14.04 197.07 12.9 196.21 12.05C194.44 10.28 191.57 10.28 189.8 12.05C188.03 13.82 188.03 16.69 189.8 18.46C190.66 19.32 191.79 19.79 193 19.79C194.04 19.79 195.02 19.42 195.82 18.78C195.84 18.81 195.85 18.84 195.87 18.86L198.14 21.13C198.25 21.24 198.4 21.3 198.54 21.3C198.68 21.3 198.83 21.24 198.94 21.13C199.16 20.91 199.16 20.55 198.94 20.33L198.95 20.32ZM190.61 17.65C189.29 16.32 189.29 14.17 190.61 12.84C191.27 12.18 192.14 11.85 193.01 11.85C193.88 11.85 194.75 12.18 195.41 12.84C196.05 13.48 196.41 14.34 196.41 15.24C196.41 16.14 196.06 17 195.41 17.64C194.13 18.92 191.89 18.92 190.6 17.64L190.61 17.65Z"
					}
					fill={"white"}
				/>
				<path
					d={
						"M635.14 52.67H717.1C723.17 52.67 728.09 57.59 728.09 63.66V402.67C728.09 408.74 723.17 413.66 717.1 413.66H635.14"
					}
					stroke={"white"}
					stroke-width={"1.2"}
					stroke-miterlimit={"10"}
				/>
				<path
					d={"M635.14 386.39H728.1"}
					stroke={"white"}
					stroke-width={"1.2"}
					stroke-miterlimit={"10"}
				/>
				<path
					d={
						"M649.1 74.67C651.862 74.67 654.1 72.4314 654.1 69.67C654.1 66.9086 651.862 64.67 649.1 64.67C646.339 64.67 644.1 66.9086 644.1 69.67C644.1 72.4314 646.339 74.67 649.1 74.67Z"
					}
					stroke={"white"}
					stroke-width={"1.2"}
					stroke-miterlimit={"10"}
				/>
				<path
					d={
						"M0 32H635V431C635 437.627 629.627 443 623 443H12C5.37259 443 0 437.627 0 431V32Z"
					}
					fill={"white"}
					fill-opacity={"0.9"}
				/>
			</g>
			<defs>
				<clipPath id={"clip0_680_3053"}>
					<rect width={"728.7"} height={"443.01"} fill={"white"} />
				</clipPath>
			</defs>
		</svg>
	)
}

export default LaptopSvg
